import { cond, constant, matches } from 'lodash-es'
import { DateTime } from 'luxon'

import { EtaLocationType, EtaRouteStatus } from '@/feature/eta'
import {
  GEO_FEATURE_MARKER_COLOR,
  MARKER_MOVING_COLOR,
  MARKER_STATIONARY_COLOR,
} from '@/feature/observatory'

const ETA_ROUTE_STATUS_MESSAGES: Record<EtaRouteStatus, string> = {
  [EtaRouteStatus.ZeroResults]: 'No valid route could be calculated',
  [EtaRouteStatus.NoRouteFound]:
    'Could not calculate an ETA to the geofence coordinates. Please ensure the geofence covers a publicly accessible area',
  [EtaRouteStatus.NotFound]: 'One or more locations could not be found',
  [EtaRouteStatus.OverQueryLimit]: 'Too many requests. Please try again later',
  [EtaRouteStatus.RequestDenied]: 'Route request was denied',
  [EtaRouteStatus.InvalidRequest]: 'Invalid route request',
}

const ETA_ROUTE_FALLBACK_MESSAGE = 'Unable to calculate route'

export const getErrorMessageForStatus = (status: string): string => {
  // API errors arrive as free-form messages that embed the status code, so match by substring.
  const matchedStatus = Object.values(EtaRouteStatus).find((code) => status.includes(code))

  return matchedStatus ? ETA_ROUTE_STATUS_MESSAGES[matchedStatus] : ETA_ROUTE_FALLBACK_MESSAGE
}

export const formatTimeStamp = (duration: number | undefined): string => {
  if (duration === undefined) {
    return 'N/A'
  }
  return DateTime.now().plus({ seconds: duration }).setLocale('en-gb').toFormat("HH':'mm")
}

export const formatDurationText = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.round((totalSeconds % 3600) / 60)
  const hoursText = hours > 0 ? `${hours} hour${hours !== 1 ? 's' : ''} ` : ''
  const minutesText = minutes > 0 ? `${minutes} min${minutes !== 1 ? 's' : ''}` : ''
  return (hoursText + minutesText).trim() || '0 mins'
}

export const color = cond([
  [matches({ type: EtaLocationType.ASSET, speed: 0 }), constant(MARKER_STATIONARY_COLOR)],
  [matches({ type: EtaLocationType.ASSET }), constant(MARKER_MOVING_COLOR)],
  [matches({ type: EtaLocationType.GEOFENCE }), constant(GEO_FEATURE_MARKER_COLOR)],
  [matches({ type: EtaLocationType.CUSTOM }), constant('#D54242')],
])

// 7% fudge factor
export const ETA_FUDGE_FACTOR = 0.07
